import Api from './api.service'

export default {
  createLibrary (object) {
    return Api().post('library/create', object)
  },
  updateLibrary (object) {
    return Api().put('library/edit/' + object.id, object.object)
  },
  libraryList (filter) {
    return Api().get('library/get', { params: filter })
  },
  getLibrary (id) {
    return Api().get('library/get/' + id)
  }
}